type Borrower = {
  customerRecordId: number;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  suffixName?: string;
};

export default class NewREO {
  addressId = 0;
  addressLdId = 0;
  addressLine1 = '';
  city = '';
  state = '';
  unit = '';
  country = 'US';
  zipCode = '';
  propertyTypeId = '';
  occupancyType = '';
  propertyStatus = '';
  marketValue = 0;
  mortgagePayment = 0;
  netRentalIncome = 0;
  isSubjectProperty = false;
  mortgageBalance = 0;
  monthlyPayment = 0;
  escrowedOnProperty = 0;
  monthlyPropertyTaxes = 0;
  monthlyHazardInsurance = 0;
  monthlyFloodInsurance = 0;
  monthlyAssociationDues = 0;
  grossRentalIncome = 0;
  leaseGroundRents = 0;
  totalMonthlyExpenses = 0;
  associatedLiabilities = [];
  associatedBorrowers: Borrower[] = [];
  constructor(id: number) {
    this.addressId = id;
  }
}
